
































































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import FormGenerator from "@/components/FormGeneration.vue";
import parseISO from "date-fns/parseISO";
import isBefore from "date-fns/isBefore";
export default Vue.extend({
  name: "product-type-details",
  components: {
    FormGenerator
  },
  data() {
    return {
      loadDone: true,
      productType: null,
      fields: null,
      mainContentFields: null,
      subContentFields: [],
      extraFields: null,
      saving: false,
      file: null,
      upLoading: false,
      specPosition: 0,
      specs: [],
      specPostionOptions: [
        {
          code: 0,
          display: "Hiển thị ở đầu mục"
        },
        {
          code: 1,
          display: "Hiển thị dưới ảnh trên"
        },
        {
          code: 2,
          display: "Hiển thị giữa mô tả SP và mô tả loại SP"
        },
        {
          code: 3,
          display: "Hiển thị trên ảnh dưới",
        },
        {
          code: 4,
          display: "Hiển thị ở cuối mục"
        }
      ],
      contentFields: [
        {
          label: "Tiêu đề mục",
          property: "title",
          placeholder: "Để trống nếu dùng biến",
          col: "is-4"
        },
        {
          label: "Màu tiêu đề",
          property: "titleColor",
          placeholder: "Màu HEX",
          inputType: "color",
          col: "is-4"
        },
        {
          label: "Trường tiêu đề",
          property: "titleField",
          placeholder: "Trường dữ liệu tên SP từ API",
          col: "is-4"
        },
        {
          type: "image",
          label: "Ảnh trên",
          property: "image",
          placeholder: "URL ảnh",
          col: "is-8"
        },
        {
          label: "Trường ảnh trên",
          property: "imageField",
          placeholder: "Trường dữ liệu mô tả SP từ API",
          col: "is-4"
        },
        {
          type: "editor",
          label: "Mô tả loại sản phẩm",
          property: "description",
          placeholder: "",
          col: "is-8"
        },
        {
          label: "Trường mô tả sản phẩm",
          property: "descriptionField",
          placeholder: "Trường dữ liệu mô tả SP từ API",
          col: "is-4"
        },
        {
          type: "image",
          label: "Ảnh dưới",
          property: "image2",
          placeholder: "URL ảnh",
          col: "is-8"
        },
        {
          label: "Trường ảnh dưới",
          property: "image2Field",
          placeholder: "Trường dữ liệu mô tả SP từ API",
          col: "is-4"
        },
      ]
    };
  },
  created() {
    this.loadItem()
  },
  computed: {
  },
  methods: {
    loadItem() {
      const code = this.$route.params.code;
      this.$store.dispatch('productType/getList', { local: false, query: { 
          limit: 1,
          filter: {
            code
          }
        } }).then(res => {
          if (res.length) {
            const productTypeRes = res[0]
            this.productType = productTypeRes
            this.specPosition = productTypeRes.specPosition || 0
            this.specs = productTypeRes.specs || []
            
            this.fields = [
              {
                label: "Mã loại sản phẩm",
                property: "code",
                col: "is-6",
                required: true,
              },
              {
                label: "Tên loại sản phẩm",
                property: "name",
                col: "is-6",
                required: true,
              },
              {
                label: "Ghi chú",
                property: "note",
                col: "is-12",
              },
              {
                label: "Màu nền (Mã HEX)",
                property: "backgroundColor",
                inputType: "color",
                placeholder: "#000",
                col: "is-4",
              },
              {
                type: "checkbox",
                label: "Form nhập thông tin",
                property: "showInfoForm",
                placeholder: "Hiển thị",
                col: "is-4",
              },
              {
                type: "checkbox",
                label: "Dialog sản phẩm Lộc Trời",
                property: "showInfoDialog",
                placeholder: "Hiển thị",
                col: "is-4",
              },
              {
                type: "image",
                label: "Ảnh nền (có thể repeat được)",
                property: "backgroundImage",
                placeholder: "URL ảnh",
                col: "is-4"
              },
              {
                type: "image",
                label: "Ảnh banner (16:9)",
                property: "banner",
                placeholder: "URL ảnh",
                col: "is-4"
              },
              {
                type: "image",
                label: "Ảnh cover (Thông tin loại sp)",
                property: "cover",
                placeholder: "URL ảnh",
                col: "is-4"
              },
            ];
            this.fields.forEach(field => {
              if (field.type == "checkbox") {
                field.current = productTypeRes[field.property] || false;
              } else {
                field.current = productTypeRes[field.property] || "";
              }
            });
            this.mainContentFields = [
              {
                col: "is-12",
                title: "Nội dung chính của sản phẩm",
                description: `Nếu muốn sử dụng nội dung của mỗi sản phẩm cụ thể, nhập tên trường dữ liệu lấy từ API của sản phẩm. 
                Nếu muốn sử dụng nội dung chung cho loại sản phẩm, nhập vào các trường còn lại.
                Các dữ liệu lấy từ API sẽ hiện trước dữ liệu của loại sản phẩm.`
              },
              ...JSON.parse(JSON.stringify(this.contentFields)),
            ]
            this.mainContentFields.forEach(field => {
              field.current = productTypeRes.mainContent ?  productTypeRes.mainContent[field.property] : ""
            });
            if (productTypeRes.subContents && productTypeRes.subContents.length) {
              productTypeRes.subContents.forEach((subContent, index) => {
                if (!Object.keys(subContent).length) return;
                this.createNewSubContent(index == 0)
              })
              this.subContentFields.forEach((subContentField, i) => {
                subContentField.forEach(field => {
                  field.current = productTypeRes.subContents[i][field.property] || ""
                });
              })
            }
            this.extraFields = [
              {
                col: "is-12",
                title: "Video",
                description: "Danh sách video của sản phẩm. Mặc định sẽ lấy dữ liệu video của sản phẩm từ API trước, sau đó mới hiện danh sách bên dưới."
             },
              {
                label: "Tiêu đề mục video",
                property: "videoTitle",
                placeholder: "Mặc định sẽ hiển thị 'Video'",
                col: "is-8", 
                current: productTypeRes["videoTitle"] || ""
              },
              {
                type: "list",
                label: "Danh sách video (Link Youtube)",
                property: "videos",
                placeholder: "Nhập URL Video và bấm Enter",
                col: "is-8", 
                current: productTypeRes["videos"] || []
              },
              {
                col: "is-12",
                title: "Chứng nhận",
                description: "Danh sách chứng nhận của sản phẩm."
             },
              {
                label: "Tiêu đề mục chứng nhận",
                property: "certificateTitle",
                placeholder: "Mặc định sẽ hiển thị 'Chứng nhận'",
                col: "is-8", 
                current: productTypeRes["certificateTitle"] || ""
              },
              {
                type: "list",
                label: "Danh sách chứng nhận",
                property: "certificates",
                placeholder: "Nhập URL ảnh và bấm Enter",
                col: "is-8", 
                current: productTypeRes["certificates"] || []
              }
            ]
            if (this.productType.subContents) this.productType.subContents = this.productType.subContents.filter(x => !!Object.keys(x).length)
            this.loadDone = true
          } else {
              this.$store.dispatch(
                "error/handleError",
                new Error("Không tìm thấy loại sản phẩm"),
                
              );
          }
        }).catch(err => {
              this.$store.dispatch(
                "error/handleError",
                err,
                "Không tìm thấy loại sản phẩm"
              );
        })
    },
    createSpec() {
      this.specs = [...this.specs, {
        name: "",
        field: ""
      }]
    },
    removeSpec(index) {
      this.specs.splice(index, 1)
      this.specs = [...this.specs]
    },
    moveUpSpec(index) {
      if (index == 0) return
      const temp = this.specs[index]
      this.specs[index] = this.specs[index - 1]
      this.specs[index - 1] = temp
      this.specs = [...this.specs]
    },
    moveDownSpec(index) {
      if (index == this.specs.length - 1) return
      const temp = this.specs[index]
      this.specs[index] = this.specs[index + 1]
      this.specs[index + 1] = temp
      this.specs = [...this.specs]
    },
    clickNewSubContent() {
      this.createNewSubContent()
      if (!this.productType["subContents"]) this.productType["subContents"] = []
      this.productType["subContents"].push({})
    },
    createNewSubContent(hasTitle) {
      this.subContentFields = [
        ...this.subContentFields,
        [
          ...hasTitle? [            
            {
              col: "is-12",
              title: "Nội dung phụ của sản phẩm",
              description: "Tạo ra một section nội dung phụ cho sản phẩm. Các dữ liệu lấy từ API sẽ hiện trước dữ liệu của loại sản phẩm."
            }
          ] : [],
          ...JSON.parse(JSON.stringify(this.contentFields))
        ]
      ]
    },
    removeSubContentFields(index) {
      this.subContentFields.splice(index, 1)
      this.productType["subContents"].splice(index, 1)
    },
    async upload() {
      this.upLoading = true;
      try {
        await this.importFarmerCampaign({
          productCampaignId: this.campaign._id,
          file: this.file
        });
        this.upLoading = false;
      } catch (error) {
        this.upLoading = false;
        console.log(error.message);
      }
    },
    testCampaign(id: string) {
      this.$router.push({ name: "campaignTest", params: { id: id } });
    },
    mainFormChanged(event) {
      this.productType["mainContent"] = { ...this.productType["mainContent"] || {}, ...event }
    },
    subFormChanged(event, index) {
      if (!this.productType["subContents"]) this.productType["subContents"] = []
      if (this.productType["subContents"][index]) this.productType["subContents"][index] = { ...this.productType["subContents"][index], ...event }
    },
    formChanged(event) {
      console.log(event)
      this.productType = {...this.productType, ...event}
    },
    async save() {
      try {
        // if (this.campaign.spinPoint < 0) {
        //   this.$buefy.toast.open({
        //     message: "Lưu thất bại: Điểm vòng quay phải lớn hơn 0!",
        //     type: "is-danger"
        //   });
        //   return;
        // }
        this.saving = true;
        await this.$store.dispatch("productType/update", {
          id: this.productType._id,
          data: {...this.productType, specs: this.specs, specPosition: this.specPosition}
        });
        this.$buefy.toast.open({
          message: "Lưu thay đổi thành công",
          type: "is-success"
        });
      } catch (err) {
        this.$store.dispatch("error/handleError", err, "Lưu thay đổi thất bại");
      } finally {
        this.saving = false;
      }
    }
  }
});
